import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export default function LearningAcademyHero({ content, publicCopy, prefix }) {
  const bullets = content.bullets || [];

  return (
    <section className="relative overflow-hidden rounded-[2rem] px-0 py-4 md:px-8 md:py-5">
      <div className="relative z-10 max-w-5xl">
        <p className="text-xs font-black uppercase tracking-[0.34em] text-[#168F92] md:text-sm">
          {publicCopy.common.publicGuide}
        </p>
        <h1 className="mt-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-heading text-[clamp(1.65rem,6.2vw,2.45rem)] font-black leading-none tracking-[-0.035em] text-[#081633] md:text-[clamp(2.25rem,4.2vw,3.25rem)]">
          {content.h1}
        </h1>
        <p className="mt-5 max-w-3xl text-base font-medium leading-7 text-[#10233E] md:text-lg">
          {content.intro}
        </p>
        <div className="mt-7 flex flex-wrap gap-3">
          <Link
            to={`${prefix}/wire`}
            className="inline-flex h-12 items-center justify-center rounded-full bg-[#17A6A4] px-6 text-sm font-black text-white shadow-[0_18px_35px_rgba(23,166,164,0.28)] transition hover:bg-[#128E8D]"
          >
            {publicCopy.common.readLatest}
          </Link>
          <Link
            to={`${prefix}/sailing-calculators`}
            className="inline-flex h-12 items-center justify-center rounded-full border border-[#9FCFD1] bg-white/82 px-6 text-sm font-black text-[#168F92] shadow-sm backdrop-blur transition hover:border-[#17A6A4] hover:bg-white"
          >
            {publicCopy.common.tryTools}
          </Link>
        </div>
      </div>

      <div className="relative z-10 mt-12 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {bullets.map((item, index) => (
          <div
            key={item}
            className={cn(
              "group relative min-h-[5.8rem] overflow-hidden rounded-[1.35rem] border p-5 text-[#081633] shadow-[0_14px_35px_rgba(8,22,51,0.08)]",
              index < 2
                ? "border-[#D6C69C] bg-[#E8D7B2]"
                : "border-[#BFDADC] bg-white/88 backdrop-blur"
            )}
          >
            <div className="absolute -bottom-8 -right-8 h-28 w-28 rounded-full border border-[#17A6A4]/10 bg-[#17A6A4]/5" />
            <div className="relative flex items-start justify-between gap-3">
              <CheckCircle2 className="h-5 w-5 shrink-0 fill-[#17A6A4] text-white" />
              <CheckCircle2 className="h-5 w-5 shrink-0 fill-[#17A6A4] text-white opacity-95" />
            </div>
            <p className="relative mt-4 text-sm font-black text-[#081633]">{item}</p>
          </div>
        ))}
      </div>
    </section>
  );
}